import request from '@/utils/request'
let baseURL = '/uc';

// 查询APP最新版本的下载链接
export function getAppVersion(appAppid, appClientType) {
  return request({
    url: `/api/app/v1/version/update/${appAppid}/${appClientType}`,
    method: 'get',
    baseURL
  })
}
